import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

import { Button, Typography } from "@novaescola/eva-react-v2";

import { AccountApi } from "../../../api/account/account.api";

const COOKIE_NAME = "ane-confirmation-block_c2855801ba";
const COOKIE_REMATRICULA_NAME = "ane-confirmation-block_bfef93f29c";
const COOKIE_CLOSE_NAME = "ane-confirmation-block_close";
const RACAS = {
  AMARELO: "Amarela",
  BRANCO: "Branca",
  INDIGENA: "Indígena",
  PARDO: "Parda",
  PRETA: "Preta",
  PREFIRO_NAO_DECLARAR: "Prefiro não declarar",
};

export const ConfirmationBlockRaca = ({ user, fetchUser }) => {
  const [hidden, setHidden] = useState(true);
  const [raca, setRaca] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [accessToken, setAccessToken] = useState("");

  useEffect(() => {
    const token = Cookies.get("Bearer");

    setAccessToken(token);
    setHidden(false);

    if (user.raca) setRaca(user.raca);

    sendEventToDataLayer(
      "block_visualization",
      "JORNALISMO: matrícula - complementação de cadastro - raça - bloco visualizado" //CONFIRMAR COM A LAÍS O PADRÃO DO EVENTO
    );
  }, []);

  const sendEventToDataLayer = (event, label) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, label });
  };

  const handleSubmit = async () => {
    setSubmitted(true);

    const response = await AccountApi.updateUserRaca(accessToken, raca);

    if (!response) {
      const expires = new Date();
      expires.setUTCDate(expires.getUTCDate() + 1);

      Cookies.set(COOKIE_CLOSE_NAME, "true", { expires });
      setHidden(true);

      return;
    }

    fetchUser(accessToken);

    const dtUltimaModificacao = new Date(user.dtUltimaModificacao);

    const lastYear = new Date();
    lastYear.setMonth(lastYear.getMonth() - 12);

    const finalEventLabel =
      user.raca &&
      (dtUltimaModificacao < lastYear || Cookies.get(COOKIE_REMATRICULA_NAME))
        ? " - rematrícula"
        : "";

    sendEventToDataLayer(
      "confirmation_block",
      `JORNALISMO: matrícula - complementação de cadastro - raça - botão enviar${finalEventLabel}`
    );
    sendEventToDataLayer(
      "confirmation_block",
      `JORNALISMO: matrícula - complementação de cadastro - raça - ${raca.toLowerCase()}`
    );

    const expires = new Date();
    expires.setUTCFullYear(expires.getUTCFullYear() + 1);

    Cookies.set(COOKIE_NAME, "true", { expires });
    setHidden(true);
  };

  const handleClose = () => {
    const expires = new Date();
    expires.setUTCDate(expires.getUTCDate() + 1);

    Cookies.set(COOKIE_CLOSE_NAME, "true", { expires });
    setHidden(true);

    sendEventToDataLayer(
      "confirmation_block",
      "JORNALISMO: matrícula - complementação de cadastro - raça - botão sair"
    );
  };

  const handleSkip = () => {
    fetchUser(accessToken);

    const expires = new Date();
    expires.setUTCFullYear(expires.getUTCFullYear() + 1);

    Cookies.set(COOKIE_NAME, "true", { expires });
    setHidden(true);

    sendEventToDataLayer(
      "confirmation_block",
      "JORNALISMO: matrícula - complementação de cadastro - raça - botão pular pergunta"
    );
  };

  if (hidden) return null;

  return (
    <div className="eva-bg-inst-50 eva-mb-07 eva-pr-05 eva-pl-05 eva-pb-05 eva-pt-05 confirmation-block">
      <div className="eva-mb-03 confirmation-block-title">
        <i className="far fa-circle-question eva-mr-03" />
        Com qual raça você se indentifica?
      </div>
      <Typography variant="body" size={3} className="eva-mb-04">
        A Nova Escola é uma ONG e essa informação nos ajuda a comprovar o
        impacto social que causamos.
      </Typography>
      <div className="confirmation-block-options-select">
        <label htmlFor="raca-select" className="eva-label">
          Raça (opcional)
        </label>
        <div className="eva-select-wrapper">
          <select
            id="raca-select"
            name="select"
            className="eva-select"
            value={raca}
            onChange={(event) => setRaca(event.target.value)}
          >
            <option disabled value="">
              Selecione uma opção
            </option>
            {Object.entries(RACAS).map(([value, text]) => (
              <option value={value} key={`raca-option-${value}`}>
                {text}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="row eva-mt-05">
        <div className="col-auto">
          <Button
            type="button"
            variant="primary"
            size="small"
            disabled={submitted || !raca}
            onClick={handleSubmit}
          >
            Enviar
          </Button>
        </div>
        <div className="col">
          <Button
            type="button"
            variant="outline-primary"
            size="small"
            onClick={handleSkip}
          >
            Pular
          </Button>
        </div>
      </div>
      <button
        type="button"
        aria-label="Fechar"
        className="eva-cursor-pointer confirmation-block-close"
        onClick={() => handleClose()}
      >
        <i className="far fa-times"></i>
      </button>
    </div>
  );
};
